import React from 'react';
import { Box, Flex, Text, Spinner, Card, CardBody } from '@chakra-ui/react';
import { IDifalPorUf } from '../../../../../../types/icms';
import { formatCurrency, toNumber } from '../../../../../../utils/FormatFunctions';

interface DifalPorUfChartProps {
  data?: IDifalPorUf[];
  isLoading?: boolean;
}

export function DifalPorUfChart({ data, isLoading }: DifalPorUfChartProps) {
  if (isLoading) {
    return (
      <Flex justify="center" py={6}>
        <Spinner color="primary" />
      </Flex>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Text color="gray.500" textAlign="center" py={4}>
        Sem dados por UF para o período.
      </Text>
    );
  }

  const max = Math.max(...data.map(d => toNumber(d.total_difal)), 1);

  return (
    <Card>
      <CardBody>
        <Text fontSize="13px" fontWeight="bold" mb={3}>
          DIFAL por UF de incidência
        </Text>
        <Box>
          {data.map(row => {
            const valor = toNumber(row.total_difal);
            const pct = (valor / max) * 100;
            return (
              <Flex key={row.uf} align="center" gap={2} mb={2} wrap="wrap">
                <Text fontSize="11px" fontWeight="bold" w="32px" flexShrink={0}>
                  {row.uf}
                </Text>
                <Box
                  flex={1}
                  minW="60px"
                  bg="gray.100"
                  borderRadius="full"
                  h="14px"
                  overflow="hidden"
                >
                  <Box
                    h="100%"
                    bg="#F57C00"
                    borderRadius="full"
                    width={`${Math.max(pct, 2)}%`}
                    transition="width 0.4s"
                  />
                </Box>
                <Text
                  fontSize="11px"
                  fontWeight="medium"
                  minW={{ base: '80px', md: '100px' }}
                  textAlign="right"
                  flexShrink={0}
                >
                  {formatCurrency(valor)}
                </Text>
                <Text
                  fontSize="10px"
                  color="gray.500"
                  minW={{ base: '50px', md: '60px' }}
                  textAlign="right"
                  flexShrink={0}
                >
                  {row.qtd_notas} {row.qtd_notas === 1 ? 'nota' : 'notas'}
                </Text>
              </Flex>
            );
          })}
        </Box>
      </CardBody>
    </Card>
  );
}
